import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ProductQueryParams, productQueryParamsToListBundlesParams} from '../../../models';
import {Bundle, PagedApiResponse} from '../../../models/clare';
import {BundleApiService} from '../../../services/bundle/bundle-api.service';
import {buildListApiQueryParams} from '../../product-list/store/product-list-query-params';

/**
 * Contains the logic for loading bundles from the backend.
 *
 */
@Injectable({providedIn: 'root'})
export class BundleListService {
  constructor(private bundleApi: BundleApiService) {}

  loadBundles(
    catalogId: number | undefined,
    queryParams: Partial<ProductQueryParams>,
    organizationId?: string
  ): Observable<PagedApiResponse<Bundle>> {
    const params = productQueryParamsToListBundlesParams(
      buildListApiQueryParams(queryParams),
      catalogId,
      organizationId
    );

    return this.bundleApi.listPaged(params);
  }
}
